import React from 'react'

export interface SplineLoadingState {
  totalIframes: number
  loadedIframes: number
  isAllLoaded: boolean
  loadingStatus: Record<string, boolean>
}

export interface SplineLoadingContextType {
  state: SplineLoadingState
  registerIframe: (id: string) => void
  markIframeLoaded: (id: string) => void
  resetState: () => void
}

export const initialSplineLoadingState: SplineLoadingState = {
  totalIframes: 0,
  loadedIframes: 0,
  isAllLoaded: false,
  loadingStatus: {},
}

export const SplineLoadingContext = React.createContext<SplineLoadingContextType | undefined>(undefined)
